document.addEventListener('DOMContentLoaded', function() {
    const hotspots = document.querySelectorAll('.hotspot-point');

    hotspots.forEach(hotspot => {
      hotspot.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // If clicking an already active one, just close it
        if (this.classList.contains('is-active')) {
          this.classList.remove('is-active');
        } else {
          // Close all others first
          hotspots.forEach(h => h.classList.remove('is-active'));
          // Open this one
          this.classList.add('is-active');
        }
      });
    });

    // Close when clicking anywhere else on the page
    document.addEventListener('click', function() {
      hotspots.forEach(h => h.classList.remove('is-active'));
    });
  });